// export const c_WEB_IP = "http://localhost:3000/";
// export const c_API_IP = "http://localhost:59818/";

// export const c_WEB_IP = "http://192.168.0.15:2407/";       // development server  
// export const c_API_IP = "http://192.168.0.15:59818/"; 

// export const c_WEB_IP = "http://192.168.0.180:80/";          // server LAN IP
// export const c_API_IP = "http://192.168.0.180:59818/";       // server LAN IP

// export const c_WEB_IP = "http://175.141.251.5:80/";          // server fixed IP
// export const c_API_IP = "http://175.141.251.5:59818/";       // server fixed IP

export const c_WEB_IP = "https://support.cimation.com.my/";     // prod server
export const c_API_IP = "https://support.cimation.com.my:59823/";

// export const c_WEB_IP = "https://175.141.251.5:9900/";        // server fixed IP
// export const c_API_IP = "https://175.141.251.5:59823/";       // server fixed IP
